module.exports = __webpack_public_path__ + "images/edge-old-1.jpg?4d0a24b7c9006d553a945a71c3c62a4e";